export default function XIcon(params: React.SVGProps<SVGSVGElement>) {
  return (
    <svg {...params} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.793 2.5H17.3486L11.7653 8.85385L18.3337 17.5H13.1907L9.16247 12.2562L4.55332 17.5H1.99611L7.96808 10.7038L1.66699 2.5H6.94056L10.5817 7.29308L14.793 2.5ZM13.896 15.9769H15.3121L6.17108 3.94308H4.65143L13.896 15.9769Z"
        fill="currentColor"
      />
    </svg>
  );
}
